// Imports


// Plugins
const plugins = [{
  location: "/Users/Bly/bachly/catholic-apparel",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins